import type { ShapeHandle, WallShape } from '@walls/store';
import { hitTestShape, hitTestShapeHandle, type BoardPoint } from './shapeGeometry';

export interface ShapeHit {
  handle: ShapeHandle;
  shape: WallShape;
}

export function hitTestShapes(
  shapes: WallShape[],
  point: BoardPoint,
  context?: CanvasRenderingContext2D | null,
  zoom = 1
): ShapeHit | null {
  const orderedShapes = [...shapes].sort((a, b) => (b.zPos ?? 0) - (a.zPos ?? 0));

  for (const shape of orderedShapes) {
    const handle = hitTestShapeHandle(shape, point, zoom);

    if (handle) {
      return { handle, shape };
    }

    if (hitTestShape(shape, point, context, zoom)) {
      return { handle: null, shape };
    }
  }

  return null;
}
